import { Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';
import { Declaration } from 'store/declarations/declaration';
import { getDeclarationUrl } from 'views/declarations/utils/getDeclarationUrl';
import { getMirroredLinks } from './getMirroredLinks';
import MirroredLinksPill from './MirroredLinksPill';
import { stopRowClick } from './stopRowClick';
import { SingleLink } from './styles';

type Props = {
    declaration: Declaration;
};

/**
 * - One mirrored declaration: a link straight to it.
 * - Several: a pill that opens the list of them.
 */
const MirroredLinksButton = ({ declaration }: Props) => {
    const { manifestId, jobId } = useParams<{ manifestId?: string; jobId?: string }>();

    const mirroredLinks = getMirroredLinks(declaration);
    if (!mirroredLinks) return null;

    if (!mirroredLinks.isSingle) {
        return (
            <MirroredLinksPill
                declaration={declaration}
                label={mirroredLinks.label}
                manifestId={manifestId}
                jobId={jobId}
            />
        );
    }

    const mirroredDeclarationId = declaration.mirrorDeclarationIdLink;
    if (!mirroredDeclarationId) return null;

    return (
        <Tooltip title="Open mirrored declaration">
            <SingleLink
                to={getDeclarationUrl({ manifestId, jobId, declarationId: mirroredDeclarationId })}
                onClick={stopRowClick}
                data-testid="declaration-mirror-link"
            >
                <LinkOutlined style={{ fontSize: 14 }} />
                {mirroredLinks.label}
            </SingleLink>
        </Tooltip>
    );
};

export default MirroredLinksButton;
